require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./data-science-2-2-2-3.json") })
        }
      }, "path---data-science-2-2-2-3");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---data-science-2-2-2-3!./.cache/json/data-science-2-2-2-3.json
// module id = 391
// module chunks = 231608221292675